<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Records Per Page</div>
      </div>
      <div class="card-content row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div v-if="false" class="col-sm-6">
          <div class="pull-right">
            <label>
              <input type="search" class="form-control input-sm" placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
            </label>
          </div>
        </div>
        <div class="col-sm-12">
          <el-table v-if="initialized"
                    class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column label="Product">
              <template slot-scope="props">
                <div class="img-container">
                  <img :src="props.row.imageUrl" width="140" height="140">
                </div>
                {{props.row.product.data.name}}
              </template>
            </el-table-column>
            <el-table-column min-width="80" label="Status">
              <template slot-scope="props">
                <strong>{{props.row.status}}</strong>
              </template>
            </el-table-column>
            <el-table-column
              min-width="80"
              class="td-number td-quantity"
              label="Qty Requested">
              <template slot-scope="props">
                {{props.row.qty}}
              </template>
            </el-table-column>
            <el-table-column
              min-width="80"
              class="td-number td-quantity"
              label="Qty Created">
              <template slot-scope="props">
                {{props.row.qtyCreated}}
              </template>
            </el-table-column>
            <el-table-column
              min-width="80"
              class="td-number td-quantity"
              label="Requested">
              <template slot-scope="props">
                {{props.row.createdAtFriendly}}
              </template>
            </el-table-column>
            <el-table-column
              min-width="80"
              class="td-number td-quantity"
              label="Printed">
              <template slot-scope="props">
                {{props.row.printedAtFriendly}}
              </template>
            </el-table-column>
            <el-table-column label="" class="buttons"  min-width="100">
              <template slot-scope="props">
                <!-- <button type="button" @click.prevent="consoleLogAuthCodeBatch(props.row)" class="btn btn-fill btn-info btn-sm">Show Codes</button> -->
                <button type="button" v-if="showPrintBtn(props.row)" @click.prevent="printAuthCodeBatch(props.row)" class="btn btn-fill btn-info btn-sm">Print Auth Labels</button>
                <button type="button" v-if="showPrintBtnLoading(props.row)" class="btn btn-info btn-sm" disabled="disabled">
                  <span class="btn-label">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  </span>
                  {{props.row.status}}
                </button>
                <button type="button" v-if="hasAmazonComFnsku(props.row)" @click.prevent="printBatchFbaLabels(props.row)" class="btn btn-fill btn-info btn-sm">Print FBA Labels</button>
                <button v-if="showPrintConfirmBtn(props.row)" style="margin-top:5px" type="button" @click.prevent="confirmPrint(props.row)" class="btn btn-fill btn-warning btn-sm">Confirm Print</button>
                <button v-if="showPrintConfirmBtnLoading(props.row)" style="margin-top:5px" type="button" class="btn btn-warning btn-sm" disabled="disabled">
                  <span class="btn-label">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  </span>
                  Confirm
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import _ from 'lodash'
  import moment from 'moment'
  import firebase from 'firebase'
  import db from '@/components/firebase/init'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    mixins: [toolboxMixin],
    props: ['accountData', 'pathDymoAuthLabel', 'pathDymoFbaLabel'],
    computed: {
      queriedData () {
        return this.tableData
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        return this.pagination.total
      },
      watchPerPage () {
        return this.pagination.perPage * this.pagination.currentPage
      }
    },
    data () {
      return {
        user: {},
        initialized: false,
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0,
          startAfter: false
        },
        tableData: [],
        prodImageMap: new Map(),
        batchIdIndexMap: new Map()
      }
    },
    methods: {
      async init () {
        this.user = await this.getCurrentUser()
        this.queryData()
      },
      async getAuthCodeBatchesTable (data) {
        // let dataUserToken = data.userToken

        // let userToken = await admin.auth().verifyIdToken(dataUserToken)
        // let accountId = userToken.accountId

        let accountId = this.user.accountId

        let accountDoc = await db.collection('accounts').doc(accountId).get()
        let qtyAuthCodeBatches = accountDoc.data().qtyAuthCodeBatches
        console.log('qty account auth code batches', qtyAuthCodeBatches)
        let perPage = parseInt(data.perPage)
        let pageNum = parseInt(data.pageNum)
        let offset = perPage * (pageNum - 1)
        let batchDocs = []
        let qs = await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).orderBy('createdAt', 'desc').limit(perPage).get()
        for (const doc of qs.docs) {
          console.log('doc', doc.data())
          let reg = {
            id: doc.id,
            data: doc.data()
          }
          reg.data.createdAtMillis = doc.data().createdAt.toMillis()
          batchDocs.push(reg)
        }
        let retVal = {
          data: {
            success: true,
            qtyAuthCodeBatches: qtyAuthCodeBatches,
            authCodeBatches: batchDocs
          }
        }
        console.log('returning', retVal)
        return retVal
      },
      async queryData () {
        if (_.isEmpty(this.user)) return []

        this.tableData = []

        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        data.accountId = this.user.accountId
        data.perPage = this.pagination.perPage
        data.pageNum = this.pagination.currentPage
        console.log('calling getAuthCodeBatchesTableData', data)

        let getAuthCodeBatchesTableData = firebase.functions().httpsCallable('getAuthCodeBatchesTableData')
        let result = await getAuthCodeBatchesTableData(data)
        // let result = await this.getAuthCodeBatchesTable(data)

        console.log('getAuthCodeBatchesTableData', result)
        this.pagination.total = result.data.qtyAuthCodeBatches
        console.log('pagination data', this.pagination)
        let authCodeBatches = result.data.authCodeBatches
        for (const batchDoc of authCodeBatches) {
          if (this.prodImageMap.get(batchDoc.data.productId) === undefined) {
            let img = await this.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x')
            this.prodImageMap.set(batchDoc.data.productId, img)
          }
          let obj = batchDoc.data
          obj.id = batchDoc.id
          obj.imageUrl = this.prodImageMap.get(batchDoc.data.productId)
          this.tableData.push(obj)
          this.batchIdIndexMap.set(obj.id, this.tableData.length - 1)
          if (obj.status === 'Requested' || obj.status === 'Processing') this.monitorAuthCodeBatch(obj)
        }
        this.pagination.startAfter = result.data.lastDoc
        console.log(this.tableData)
        this.initialized = true
      },
      monitorAuthCodeBatch (authCodeBatch) {
        db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).doc(authCodeBatch.id)
        .onSnapshot(doc => {
          this.tableData[this.batchIdIndexMap.get(doc.id)].status = doc.data().status
          this.tableData[this.batchIdIndexMap.get(doc.id)].qtyCreated = doc.data().qtyCreated
        })
      },
      prettyAddress (regRecord) {
        let address = ''
        if (regRecord.address1) address += regRecord.address1
        if (regRecord.address2) address += '<br>' + regRecord.address2
        if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
          let region = ''
          if (regRecord.city) region += regRecord.city
          if (regRecord.state) {
            if (region === '') region += regRecord.state
            else region += ', ' + regRecord.state
          }
          if (regRecord.zip) {
            if (region === '') region += regRecord.zip
            else region += ' ' + regRecord.zip
          }
          if (regRecord.country) {
            if (region === '') region += regRecord.country
            else region += ' ' + regRecord.country
          }
          if (region !== '') region = '<br>' + region
          address += region
        }
        return address
      },
      friendlyDateTime (timestamp) {
        if (timestamp === undefined || timestamp === '') return 'Never'
        else return moment(timestamp.seconds * 1000).format('LLL')
      },
      formatLastPrinted (timestamp) {
        // sfd = new SimpleDateFormat('MM-dd-YYYY')
        // return sfd.format(new Date(timestamp))
        // return timestamp.seconds
        if (timestamp === undefined || timestamp === '') return 'Never'
        else return moment(timestamp.seconds * 1000).format('l')
      },
      printBatchFbaLabels (authCodeBatch) {
        console.log('dymo paths', [this.pathDymoAuthLabel, this.pathDymoFbaLabel])
      },
      showPrintBtn (authCodeBatch) {
        return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed'
      },
      showPrintBtnLoading (authCodeBatch) {
        return authCodeBatch.status === 'Requested' || authCodeBatch.stats === 'Processin' || authCodeBatch.status === 'Printing'
        // return (
        //   authCodeBatch.status === 'Requested' || authCodeBatch.status === 'Processing' || authCodeBatch.status === 'Printing' ||
        //   (this.loading && (authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed'))
        // )
      },
      showPrintConfirmBtn (authCodeBatch) {
        return authCodeBatch.status === 'Printed'
      },
      showPrintConfirmBtnLoading (authCodeBatch) {
        return authCodeBatch.confirmingPrint && authCodeBatch.status === 'Printed'
      },
      hasAmazonComFnsku (authCodeBatch) {
        return !!authCodeBatch.product.data.amazonComFnsku
      }
    },
    watch: {
      watchPerPage: function (newFrom, oldFrom) {
        this.queryData()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.btn {
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/AuthCodeBatchesTable.vue